import React, { memo } from "react";
import classes from "./Header.scss";
import { CloseOutlined } from "@toddle-edu/ds-icons";
import classNames from "classnames";
import { IconButton } from "@toddle-edu/ds-web";
import { UnitSummaryIcon } from "SvgComponents";
import { colors } from "Constants";

const Header = memo(function Header(props) {
  const { onClose, t, testId, isUnitFlowRevamp } = props;

  const headerClasses = classNames(classes.header, {
    [classes.headerRevamp]: isUnitFlowRevamp,
  });

  const headingClasses = classNames(classes.heading, {
    "heading-6": isUnitFlowRevamp,
    "heading-5": !isUnitFlowRevamp,
    [classes.headingRevamp]: isUnitFlowRevamp,
  });

  return (
    <div className={headerClasses}>
      <div className={classes.headerDetails}>
        {!isUnitFlowRevamp ? (
          <UnitSummaryIcon fill={colors.grass} width={20} height={20} />
        ) : null}
        <div className={headingClasses}>{t("common:planner_overview")}</div>
      </div>
      <IconButton
        icon={<CloseOutlined variant={"subtle"} />}
        size={isUnitFlowRevamp ? "x-small" : "medium"}
        _legacy_variant={"plain"}
        variant="neutral"
        type="plain"
        _legacy_size={isUnitFlowRevamp ? "x-small" : "medium"}
        testId={`${testId}-close`}
        onClick={onClose}
      />
    </div>
  );
});

export default Header;
